import { render, staticRenderFns } from "./formtableview.vue?vue&type=template&id=7084ab2f&scoped=true"
import script from "./formtableview.vue?vue&type=script&lang=js"
export * from "./formtableview.vue?vue&type=script&lang=js"
import style0 from "./formtableview.vue?vue&type=style&index=0&id=7084ab2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084ab2f",
  null
  
)

export default component.exports